/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "twitter-a6b6ec15--sprite",
  "use": "twitter-a6b6ec15--sprite-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"twitter-a6b6ec15--sprite\"><path d=\"M22 5.939a8.193 8.193 0 01-2.356.646 4.12 4.12 0 001.804-2.268 8.272 8.272 0 01-2.607.996 4.103 4.103 0 00-6.991 3.74 11.648 11.648 0 01-8.457-4.286 4.072 4.072 0 00-.554 2.062 4.1 4.1 0 001.824 3.414 4.104 4.104 0 01-1.858-.515v.052a4.107 4.107 0 003.29 4.023 4.155 4.155 0 01-1.08.143c-.266 0-.522-.026-.773-.076a4.105 4.105 0 003.832 2.85 8.232 8.232 0 01-5.095 1.753A8.73 8.73 0 012 18.417a11.598 11.598 0 006.289 1.846c7.547 0 11.673-6.252 11.673-11.673l-.014-.531A8.193 8.193 0 0022 5.939z\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
